import Table from '@modules/Table'
import React, { useEffect } from 'react'
import { Column } from 'react-table'
import { Options } from '../Table/types'
import useAddAction from './hooks/useAddAction'
import useEditAction from './hooks/useEditAction'
import useResourceTableOptions from './hooks/useResourceTableOptions'

const Resource = <T extends ObjectWithId>({ form, label, controller, columns, cache, actions, heading, onChange }: Props<T>) => {
    const resource = controller.index.use(cache) as Hooks.UseApiController.Methods.Index.Use.Response<T>
    useEffect(() => onChange?.(resource.data), [resource.data])

    const edit = useEditAction({ form, label, controller, resource })
    const add = useAddAction({ form, label, controller, resource })
    const options = useResourceTableOptions<T>(actions, edit, add, heading)
    return <Table data={resource.data} columns={columns} options={options} />
}

export default Resource

interface Props<T extends ObjectWithId> {
    form: React.FunctionComponent<Modules.Resource.Form<T>>
    label: string
    columns: Column<T>[]
    controller: Hooks.UseApiController.Methods
    actions?: Options<T>["actions"]
    heading?: Options<T>["heading"]
    cache?: string
    onChange?(data: T[] | undefined): void
}